module.exports = __webpack_public_path__ + "static/media/ER-RUS1_1BTMfEXu88ZC6D5upFaILb-QYccTJ-Ro2.5c384069.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/ER-RUS1_1BTMfEXu88ZC6D5upFaILb-QYccTJ-Ro2
// module id = 840
// module chunks = 0